import styled from 'styled-components';
import { TGoogleMapProps } from './GoogleMap.types';
import { radius } from '@/styles/Themes/Metrics';
import Screen from '@/styles/Themes/Screen';

export const StyleGoogleMap = styled.div<TGoogleMapProps>`
    /* margin: 0 auto;

    max-height: ${(props) =>
        typeof props.height === 'number' ? `${props.height}px` : props.height};

    max-width: ${(props) =>
        typeof props.maxWidth === 'number' ? `${props.maxWidth}px` : props.maxWidth}; */

    > iframe {
        border-radius: ${radius.small};
        height: 372px;

        ${Screen.desktop} {
            height: 589px;
        }
    }
`;
